/**
 * Mile copy for the getting-there rows (WEB-1189 C13).
 *
 * Distances use `formatDistanceMilesLabel` (one decimal under a mile, whole
 * miles above). A distance that rounds to zero renders "Under 0.1 mi walk".
 * Estimated minutes keep the `~` marker (WEB-415).
 */
import { formatDistanceMilesLabel } from '@/lib/discover/rowMetaLine';

/** Walk-row detail: `0.2 mi walk`, or `Under 0.1 mi walk` when miles round to zero. */
export function walkDetailFromMeters(meters: number): string {
  const label = formatDistanceMilesLabel(meters);
  if (label == null) return 'Under 0.1 mi walk';
  return `${label} walk`;
}

/** Coarse walk-time estimate. The `~` marks that the minutes are not measured. */
export function walkMetricMinutes(walkMinutes: number): string {
  return `~${walkMinutes} min`;
}

/**
 * Parking / non-walk distance. `0` metres is "At venue". A positive distance
 * that rounds to zero keeps the "from venue" words without printing `0 mi`.
 */
export function distanceFromVenueDetail(meters: number): string {
  if (meters === 0) return 'At venue';
  const label = formatDistanceMilesLabel(meters);
  if (label == null) return 'Under 0.1 mi from venue';
  return `${label} from venue`;
}
